import React from "react";
import "./App.css";

export default function (props) {
  if (props.photos) {
    console.log(props);
    return (
      <section className="photos">
        <div className="row photo-row">
          {props.photos.map(function (photo, index) {
            return (
              <div className="col-4" key={index}>
                <a href={photo.src.original} target="_blank">
                  <img src={photo.src.landscape} className="img-fluid" />
                </a>
              </div>
            );
          })}
        </div>
      </section>
    );
  } else {
    return null;
  }
}
